import { Box, Divider, InputBase, Typography } from '@mui/material'
import React, { useEffect, useMemo } from 'react'
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import { phoneLength } from './phoneLength';
import { getAllISOFromDialCode } from 'utils/function';
const CustomPhoneContryCodeInput = ({ value, onChange, placeholder, error, helperText, countryCode: propsCountryCode, country_ISO: propsCountryISO }) => {
    const vendorCountry = useSelector((state) => state?.posData?.country_code);
    const countryCode = propsCountryCode || vendorCountry;

    const countryISOFromDialCode = getAllISOFromDialCode(countryCode);
    const country_ISO = propsCountryISO || (Array.isArray(countryISOFromDialCode) ? countryISOFromDialCode[0] : countryISOFromDialCode);

    // memoize max length for this countryCode
    const maxLength = useMemo(() => {
        if (!country_ISO) return phoneLength["GB"]
        return (
            phoneLength[country_ISO] ??
            phoneLength["GB"]
        )
    }, [country_ISO])
    // helper to keep only digits
    const digitsOnly = (val) => (val || "").toString().replace(/\D/g, "")

    // handle user typing / editing
    const handleChange = (e) => {
        const raw = e?.target?.value ?? ""
        let digits = digitsOnly(raw)

        if (digits.length > maxLength) {
            digits = digits.slice(0, maxLength)
        }

        // call parent's onChange with an event-like object (keeps your current usage)
        if (typeof onChange === "function") {
            onChange({ target: { value: digits } })
        }
    }


    // handle paste — prevent default paste and insert truncated digits
    const handlePaste = (e) => {
        e.preventDefault()
        const pasted = (e.clipboardData || window.clipboardData).getData("Text")
        let digits = digitsOnly(pasted)
        if (digits.length > maxLength) digits = digits.slice(0, maxLength)
        if (typeof onChange === "function") {
            onChange({ target: { value: digits } })
        }
    }

    // If country code / maxLength changes, trim current value if needed
    useEffect(() => {
        const currentDigits = digitsOnly(value)
        if (currentDigits.length > maxLength) {
            const trimmed = currentDigits.slice(0, maxLength)
            if (typeof onChange === "function") {
                onChange({ target: { value: trimmed } })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [country_ISO, maxLength])

    return (
        <>
            <Box className='d-flex align-items-center'
                sx={{
                    border: error ? '1px solid #d32f2f' : '1px solid #A1A1A1',
                    borderRadius: 2,
                    width: "100%",
                }}
            >
                <Box sx={{ px: 1.2, display: 'flex', alignItems: 'center' }}>
                    <Typography className='d-flex align-items-center'>
                        <AddIcon fontSize={"10px"} />
                        {countryCode}
                    </Typography>
                </Box>
                <Divider
                    orientation="vertical"
                    flexItem
                    sx={{
                        height: '30px',
                        borderRightWidth: '1.5px',    // ← thicker border
                        borderColor: '#A1A1A1',
                        mt: 0.7,
                    }}
                />

                <InputBase
                    placeholder={placeholder}
                    value={value}
                    // onChange={onChange}
                    onChange={handleChange}
                    onPaste={handlePaste}
                    sx={{ pl: 1, pr: 1, height: 40, flex: 1, fontSize: '0.875rem' }}
                    inputProps={{ maxLength, sx: { padding: '0px' } }}
                />
            </Box>
            {
                helperText && (
                    <Typography variant="caption" color={error ? 'error' : 'textSecondary'} sx={{ mt: 0.5 }}>
                        {helperText}
                    </Typography>
                )
            }
        </>
    )
}

export default CustomPhoneContryCodeInput
